import { render, staticRenderFns } from "./ChannelCopyModal.vue?vue&type=template&id=24c9a17a&"
import script from "./ChannelCopyModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelCopyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports